import {
  SET_BUSINESS_UUID,
  SET_IS_LOADING,
  SET_TOKENS,
  CLEAR_TOKEN
} from './constants';

const initialState = {
  isLoading: false,
  businessUuid: '',
  list: []
}

const openApiReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_IS_LOADING: {
      return {
        ...state,
        isLoading: action.payload
      }
    }
    case SET_BUSINESS_UUID: {
      return {
        ...state,
        businessUuid: action.payload
      }
    }
    case SET_TOKENS: {
      return {
        ...state,
        list: action.payload
      }
    }
    case CLEAR_TOKEN: {
      return {
        ...state,
        list: []
      }
    }
    default: {
      return state;
    }
  }
}

export default openApiReducer;